<template>
  <div class="filter-dropdown-content" ref="dropdownFilterRef">
    <div
      role="button"
      class="filter-selected"
      @click="onOpenDropdown"
    >
      <p>{{ selected.label }}</p>
      <i class="bx bx-caret-up" v-if="isOpenDropdownFilter" />
      <i class="bx bx-caret-down" v-else />
    </div>
    <div class="filter-dropdown" v-if="isOpenDropdownFilter">
      <div
        v-for="(opt, index) of options"
        :key="`option-${index}`"
        class="filter-item"
        :class="{ 'selected-filter': selected && selected.value === opt.value }"
        @click="handleOnSelected(opt)"
      >
      <p>{{ opt.label }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DropdownFilterWidget',
  props: {
    selected: {
      type: Object,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpenDropdownFilter: false,
    };
  },
  methods: {
    onOpenDropdown() {
      this.isOpenDropdownFilter = !this.isOpenDropdownFilter;
    },
    handleOnSelected(selectedObject) {
      this.$emit('onSelected', selectedObject);
      this.isOpenDropdownFilter = false;
    },
    handleClickOutside(event) {
      if (this.$refs.dropdownFilterRef && !this.$refs.dropdownFilterRef.contains(event.target)) {
        this.isOpenDropdownFilter = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>
<style lang="scss" scoped>
.filter-dropdown-content {
  min-width: 170px;
  max-width: max-content;
  p {
    margin-bottom: 0px;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: #111b49;
  }
  .filter-selected {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    border: 1px solid #dadce4;
    border-radius: 8px;
    min-width: 130px;
    height: 40px;
    background-color: #FFFFFF;
    cursor: pointer;
    i {
      color: #868ba6;
    }
  }
  .filter-dropdown {
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid #dadce4;
    position: absolute;
    margin-top: 4px;
    padding: 8px 12px;
    min-width: 170px;
    max-width: max-content;
    z-index: 4;
    .filter-item {
      padding: 8px 0px;
      cursor: pointer;
    }
    .selected-filter {
      padding: 8px 0px;
      color: #2962df;
    }
  }
}
</style>
